import { render, staticRenderFns } from "./LeaderboardItem.vue?vue&type=template&id=467a816a&"
import script from "./LeaderboardItem.vue?vue&type=script&lang=js&"
export * from "./LeaderboardItem.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports